import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactPixel from "react-facebook-pixel";
import { GA_ID, PIXEL_ID } from "shared/constants";

import { shopifyExchangeCode, clearLoginError } from 'redux/users/actions';

import AuthLayout from 'components/authentication/AuthLayout';
import LoginForm from 'components/authentication/LoginForm';
import ReactGA from "react-ga";
import {SITE_URL} from "utils/restapi";


const APP_ID = '5df211fdccca6624ca9decc2bd94361f';
const CALLBACK_URL = `${SITE_URL}/login/shopify`;
const SCOPE = 'read_products,read_product_listings';


class ShopifyLoginPage extends PureComponent {
  static propTypes = {
    shopifyExchangeCode: PropTypes.func.isRequired,
    clearLoginError: PropTypes.func.isRequired,
    loginError: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape,
    ]),
    accessToken: PropTypes.string,
    isRegistered: PropTypes.bool,
    location: PropTypes.oneOfType([
      PropTypes.shape,
    ]),
  };

  static defaultProps = {
    loginError: null,
    accessToken: null,
    isRegistered: false,
    location: null,
  };

  _extractCode = search => {
    return new URLSearchParams(search).get('code');
  }

  _extractShop = search => {
    return new URLSearchParams(search).get('shop');
  }

  _connectShopifyStore = () => {
    const connectionData = this.props.location.search.split('&');
    const code = connectionData[0].replace('?code=', '');
    const hmac = connectionData[1].replace('hmac=', '');
    const shop = connectionData[2].replace('shop=', '');
    this.props.shopifyExchangeCode(code, hmac, shop);
    setTimeout(() => {
      this.props.history.push('/integrations/shopify');
    }, 4000);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.isRegistered && this.props.isRegistered) {
      ReactGA.initialize(GA_ID);
      ReactGA.event({
        category: 'New User',
        action: 'Sign Up',
        label: 'Sign Up Page Form',
      });
      const pixelOptions = {
        autoConfig: true,
        debug: false,
      };
      ReactPixel.init(PIXEL_ID, null, pixelOptions);
      ReactPixel.track('CompleteRegistration');
      // TikTok Pixel Registration event
      if (window.ttq) {
        window.ttq.track('Registration');
      }
      // Yandex Metrika
      if (window.ym) {
        window.ym(69416935, "reachGoal", "SIGNUP");
      }
    }
  }

  componentDidMount() {
    if (this.props.location) {
      const code = this._extractCode(this.props.location.search);
      const shop = this._extractShop(this.props.location.search);

      if (shop && !code) {
        window.location.href = `https://${shop}/admin/oauth/authorize?client_id=${APP_ID}&scope=${SCOPE}&redirect_uri=${CALLBACK_URL}`;
      } else if(shop && code) {
        this._connectShopifyStore();
      } else {
        // this.props.history.push('/');
      }
    }
  }

  componentWillUnmount() {
    this.props.clearLoginError();
  }

  render() {
    return (
      <AuthLayout type="shopifyOAuth" className="login-page__component">
        {!this.props.loginError ?
          <div>
            <Header as="h1">Log In</Header>
            <p>Please, wait...</p>
          </div>
          :
          <LoginForm />
        }
      </AuthLayout>
    );
  }
}


const mapStateToProps = state => (
  {
    accessToken: state.usersReducer.accessToken,
    refreshToken: state.usersReducer.refreshToken,
    loginError: state.usersReducer.loginError,
    isRegistered: state.usersReducer.isRegistered,
  }
);

export default connect(
  mapStateToProps,
  {
    shopifyExchangeCode,
    clearLoginError,
  },
)(ShopifyLoginPage);
